"use client";

import NavList from "../NavList";
import { API_BASE_URL, CONTRACT_PDF_URL } from "../../../config";
import { usePaymentMethods } from "../../eCommerce/hooks/use-payment-methods";
import { Spinner } from "react-bootstrap";

const TermsConditionsContent = () => {
  const {
    countryInfo,
    isLoading: isLoadingPaymentMethods,
    isError: isErrorPaymentMethods,
  } = usePaymentMethods();

  const documents = [
    { key: "personalDataAuthorization", label: "Autorización de Datos Personales" },
    { key: "sanitaryRegistration", label: "Registro Sanitario" },
    { key: "termsAndConditions", label: "Términos y Condiciones" },
  ];

  const availableDocuments = documents.filter((doc) => countryInfo?.[doc.key]);

  return (
    <div className="bg-white p-4 rounded-3 mb-4">
      <NavList />

      <ul className="list-unstyled">
        <li className="mb-3">
          <a
            href={CONTRACT_PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="document-link text-decoration-none text-primary"
          >
            Descargar Contrato de Vinculación Comercial de Vendedor Independiente
          </a>
        </li>
      </ul>

      {isLoadingPaymentMethods ? (
        <div className="text-center py-4">
          <Spinner animation="border" />
        </div>
      ) : isErrorPaymentMethods ? (
        <div className="text-danger">Error al cargar los documentos</div>
      ) : availableDocuments.length === 0 ? (
        <div className="text-muted">No hay documentos adicionales disponibles para tu país</div>
      ) : (
        <ul className="list-unstyled">
          {availableDocuments.map((doc) => {
            const fileName = countryInfo?.[doc.key];
            return (
              <li key={doc.key} className="mb-3">
                <a
                  href={`${API_BASE_URL}/product/countries-available/get-file/${fileName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="document-link text-decoration-none text-primary"
                >
                  Descargar {doc.label}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default TermsConditionsContent;
